import { render, staticRenderFns } from "./ticket-filter.vue?vue&type=template&id=10df937d"
import script from "./ticket-filter.vue?vue&type=script&lang=js"
export * from "./ticket-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports